import { type ReactNode, useState, useEffect } from 'react';

const PHRASES = [
  'Eligiendo a los mejores...',
  'Verificando tu perfil...',
  'Analizando tus respuestas...',
];
const PHRASE_INTERVAL_MS = 2000;

function useRotatingPhrase(): string {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(
      () => setIdx((i) => (i + 1) % PHRASES.length),
      PHRASE_INTERVAL_MS
    );
    return () => clearInterval(id);
  }, []);
  return PHRASES[idx]!;
}

export function LoadingPhase(): ReactNode {
  const phrase = useRotatingPhrase();
  return (
    <div className="flex flex-col items-center gap-lg py-xl">
      <div className="relative h-9 w-9">
        <div className="glass-ring absolute inset-0" />
        <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-transparent border-t-brand-red" />
      </div>
      <p className="animate-pulse text-sm text-text-secondary">{phrase}</p>
    </div>
  );
}
